import { sendPrescriptionsToPharmacy } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SendPrescriptionsRequestT,
  SendPrescriptionsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSendPrescriptionsToPharmacy(
  userId: string,
  request: SendPrescriptionsRequestT,
  signal?: AbortSignal
): Promise<SendPrescriptionsResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await sendPrescriptionsToPharmacy(userId, request, config);
  return lotusHealthZod.sendPrescriptionsToPharmacyResponse.parse(
    response.data
  ) as SendPrescriptionsResponseT;
}
